import { component } from 'picoapp';
import KeenSlider from 'keen-slider';
import lazySizes from 'lazysizes';

export default component((node) => {
  const slider = node.querySelector<HTMLElement>('[data-slider]');
  const slides = slider.querySelectorAll('[data-slide]');

  /* eslint-disable no-new */
  new KeenSlider(slider, {
    mode: 'free-snap',
    slidesPerView: 1.1,
    spacing: 20,
    duration: 1200,
    breakpoints: {
      '(min-width: 768px)': {
        slidesPerView: slides.length,
        dragSpeed: 0,
      },
    },

    mounted() {
      lazySizes.autoSizer.checkElems();
    },

    slideChanged() {
      lazySizes.autoSizer.checkElems();
    },
  });
});
